<template>
  <div class='indexbox'>
    <!-- <nav-bar :title="$t('品鉴商城')" left-arrow /> -->
    <wallet-head show_type="10" />

    <van-list v-model="loading" :finished="finished" :finished-text="$t('没有更多了')" @load="onLoad" :offset="0">
      <div class="listbox">
        <div class="item" v-for="val in list" :key="val.id">
          <img v-lazy="val.img[0].url" alt="">
          <p class="n one">{{ val.name }}</p>
          <p class="p one">{{ $t('价值') }}：{{ val.price }}T</p>
          <p class="one">{{ $t('收益率') }}：{{ val.rate }}%</p>
          <!-- <p class="one">{{ $t('周期') }}：{{ val.cycle }}</p> -->
          <p class="one">{{ $t('购买次数') }}：{{ val.buy_count }} /{{ val.limit }}</p>
          <van-button size="mini" :disabled="val.buy_count >= val.limit" round
            color=" linear-gradient( 90deg, #EBC699 0%, #CD823A 100%)" @click="save(val)">
            {{ $t('购买') }}</van-button>
        </div>
      </div>
    </van-list>

    <!-- <van-dialog v-model="show" :title="$t('购买')" show-cancel-button @confirm="confirm" @cancel="cancel">
      <div class="inp">
        <van-field v-model="trade_password" type="password" maxlength="6" :placeholder="$t('请输入交易密码')" clearable
          :border="false" />
      </div>
    </van-dialog> -->

    <!-- <van-popup v-model="tipshow" style="width: 80%;" :close-on-click-overlay="false">
      <div class="popupbox">
        <div class="body">
          <div class="ti">{{ $t('提示') }}</div>
          <div class="content">
            <p>{{ tipmsg }}</p>
            <van-button round color="linear-gradient( 90deg, #EBC699 0%, #CD823A 100%)" @click="tipshow = false">
              {{ $t('确定') }}</van-button>
          </div>
        </div>
        <img src="@/assets/img/guanbi@2x.png" alt="" @click="tipshow = false">
      </div>
    </van-popup> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      page: 1,
      loading: false,
      finished: false,

      show: false,
      product_id: '',
      usdt_price: '',
      trade_password: '',
      address: "",
      bloading: false,

      tipmsg: '',
      tipshow: false,
    }
  },
  computed: {},
  watch: {},
  created() {
    // this.getdata()
  },
  methods: {
    // getdata() {
    //   this.$get({
    //     url: "/api/v1/user/invest/setting",
    //     success: (res) => {
    //       this.address = res.data.address
    //     },
    //     tip: () => { },
    //   })
    // },
    onLoad() {
      let page = this.page++
      this.$get({
        url: "/api/v1/product",
        data: {
          page,
        },
        success: (res) => {
          if (!res.data || res.data.data.length == 0) {
            this.finished = true
          } else {
            var list = res.data.data
            if (page == 1) {
              this.list = list
            } else {
              for (var i in list) {
                this.list.push(list[i])
              }
            }
          }
          this.loading = false
        },
        tip: () => {
          this.finished = true
        },
      })
    },
    save(data) {
      console.log(data)
      let obj = {
        buy_count: data.buy_count,
        created_at: data.created_at,
        cycle: data.cycle,
        equity: data.equity,
        id: data.id,
        img: data.img[0].url,
        limit: data.limit,
        name: data.name,
        price: data.price,
        rate: data.rate,
        usdt_price: data.usdt_price
      }
      this.router('morder', obj)
    },
    // submit(data) {
    //   this.product_id = data.id
    //   this.usdt_price = data.usdt_price
    //   this.trade_password = ''
    //   this.show = true
    // },
    // cancel() {
    //   this.product_id = ''
    //   this.usdt_price = ''
    //   this.trade_password = ''
    //   this.show = false
    // },

    // confirm() {
    //   if (!this.address) return this.$toast(this.$t("暂无收汇地址"))
    //   if (!this.trade_password) return this.$toast(this.$t("请输入交易密码"))
    //   if (this.bloading) return;
    //   this.$toast.loading({
    //     duration: 0,
    //     overlay: true
    //   })
    //   this.bloading = true
    //   let that = this
    //   that.$nextTick(() => {
    //     console.log("1", that.address)
    //     that.blockFun
    //       .transfer("usdt", String(that.usdt_price), that.address, "ether", false)
    //       .then((hash) => { that.payOrder(hash) }).catch((err) => {
    //         that.loading = false
    //         that.$toast.fail(that.$t(err.msg))
    //       })
    //   })
    // },
    // payOrder(hash) {
    //   this.$post({
    //     url: "/api/v1/user/buy_machine",
    //     loading: true,
    //     data: {
    //       product_id: this.product_id,
    //       trade_password: this.trade_password,
    //       hash,
    //       status: 4,
    //     },
    //     success: (res) => {
    //       this.cancel()
    //       this.bloading = false
    //       this.$toast({
    //         message: this.$t('成功'),
    //         onClose: () => {
    //           this.page = 1
    //           this.finished = false
    //           this.onLoad()
    //         }
    //       })
    //     },
    //     tips: (err) => {
    //       this.$toast.clear()
    //       this.bloading = false
    //       this.loading = false
    //       this.show = false
    //       this.tipmsg = err.message
    //       this.tipshow = true
    //     },
    //   })
    // }
  },
}
</script>
<style lang='less' scoped>
.listbox {
  width: 100%;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;

  .item {
    width: 48%;
    background: #1A1C1D;
    border-radius: 6px;
    padding: 8px 10px 16px;
    margin-bottom: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100px;
      height: 100px;
      margin-bottom: 5px;
    }

    >p {
      width: 100%;
      line-height: 1.6;
      color: #C7C7CC;
      font-size: 12px;
    }

    .n {
      color: #FFFFFF;
      font-size: 17px;
      font-weight: 550;
    }

    .p {
      color: #E6B17F;
      padding: 2px 0 0;
    }

    /deep/.van-button {
      width: 90%;
      padding: 14px 10px;
      margin-top: 10px;

      .van-button__text {
        color: #fff;
        font-size: 14px;
      }
    }
  }
}

/deep/.van-popup {
  background: none;

  .popupbox {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .body {
      width: 100%;
      background: #fff;
      border-radius: 12px;
      overflow: hidden;
      margin-bottom: 20px;

      .ti {
        width: 100%;
        background: linear-gradient(90deg, #EBC699 0%, #CD823A 100%);
        padding: 11px 0;
        color: #fff;
        font-size: 18px;
        text-align: center;
      }

      .content {
        width: 100%;
        padding: 25px 20px 48px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        >p {
          color: #333333;
          font-size: 14px;
          margin-bottom: 35px;
        }

        .van-button {
          width: 60%;
          padding: 14px 10px;

          .van-button__text {
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }

    img {
      width: 50px;
      height: 50px;
    }
  }
}

.inp {
  width: 100%;
  padding: 30px 20px;

  /deep/.van-cell {
    border: 1px solid #ccc;
    padding: 13px 10px;

    .van-field__control {
      color: #fff;
    }
  }
}
</style>